// src/app/app-routing.module.ts
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Apps } from './modules/apps/apps';
import { Status } from './layout/status/status';
import { LanguageGuard } from './core/guards/language-guard-guard'; // Temporarily disabled
import { StepGuard } from './core/guards/step-guard-guard';



export const routes: Routes = [
  // Root → default language
  { path: '', redirectTo: 'en/apps', pathMatch: 'full' },

  // ===== WITHOUT language (auto-redirects to defaultLang) =====
  { path: 'apps', redirectTo: 'en/apps', pathMatch: 'full' },
  { path: 'apps/reseller', redirectTo: 'en/apps/reseller', pathMatch: 'full' },
  { path: 'cloud', redirectTo: 'en/cloud', pathMatch: 'full' },
  { path: 'cloud/sddc-flex', redirectTo: 'en/cloud/sddc-flex', pathMatch: 'full' },
  { path: 'cloud/openstack-flex', redirectTo: 'en/cloud/openstack-flex', pathMatch: 'full' },

  // Redirects for office365 without language
  { path: 'office365/:subpath', redirectTo: 'en/office365/:subpath' },
  { path: 'office365', redirectTo: 'en/office365', pathMatch: 'full' },

  // ===== Status without language =====
  { path: 'status', component: Status },

  // ===== WITH language =====
  {
    path: ':lang',
    canActivate: [LanguageGuard],
    children: [
      { path: '', redirectTo: 'apps', pathMatch: 'full' },

      {
        path: 'apps/reseller',
        loadChildren: () =>
          import('./modules/reseller/reseller-module').then(m => m.ResellerModule),
        canActivate: [StepGuard]
      },
      {
        path: 'apps',
        loadChildren: () =>
          import('./modules/apps/apps-module').then(m => m.AppsModule),
        canActivate: [StepGuard]
      },
      {
        path: 'office365',
        loadChildren: () =>
          import('./modules/office365/office365-module').then(m => m.Office365Module),
        canActivate: [StepGuard]
      },
      {
        path: 'cloud',
        loadChildren: () =>
          import('./modules/cloud/cloud-module').then(m => m.CloudModule),
        canActivate: [StepGuard]
      },
    ],
  },

  // ===== Status with language =====
  { path: ':lang/status', component: Status },

  // ===== Global fallback =====
  { path: '**', redirectTo: 'en/apps' },
];



@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
